import { Box, Button, Card, CircularProgress, Link } from '@mui/material';
import { useGetUserOpenAiProcesses } from '../../apollo/queries/getOpenAiProcess.web.graphql';
import { useEffect, useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { blue, grey, orange } from '@mui/material/colors';
import { generatePath } from 'react-router-dom';
import { paths } from '../../routing/Router/paths';
import { formatDate } from '../../utils/dateUtils';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export const SlideshowGenerateList = () => {
  const { data, loading, refetch } = useGetUserOpenAiProcesses();
  const [activeProcessId, setActiveProcessId] = useState<string | null>(null);

  useEffect(() => {
    const isRunning = data?.openAiProcesses.some(
      (process) => process.status === 'RUNNING',
    );

    if (isRunning) {
      const intervalId = setInterval(() => {
        refetch();
      }, 5000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [data, refetch]);

  return (
    <Card
      variant="outlined"
      sx={{
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.15)',
      }}
    >
      {loading && <Box>Chargement...</Box>}
      {data &&
        data.openAiProcesses.map((process) => {
          const isCreationSideshow = process.slideshowSubject;

          return (
            <Card
              key={process.id}
              sx={{
                padding: 2,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '3px',
                      marginBottom: '5px',
                      color: isCreationSideshow ? blue[500] : orange[500],
                    }}
                  >
                    <AutoFixHighIcon fontSize="small" />
                    {isCreationSideshow ? 'Création' : 'Edition'}
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '3px',
                      marginBottom: '5px',
                    }}
                  >
                    <Box
                      sx={{
                        fontWeight: 'bold',
                      }}
                    >
                      Date de création:
                    </Box>
                    <Box>
                      {formatDate(process.createdAt, 'dd/MM/yyyy à HH:mm')}
                    </Box>
                  </Box>
                  {isCreationSideshow ? (
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '3px',
                        marginBottom: '5px',
                      }}
                    >
                      <Box
                        sx={{
                          fontWeight: 'bold',
                        }}
                      >
                        Recherche:
                      </Box>
                      <Box>{process.slideshowSubject}</Box>
                    </Box>
                  ) : null}
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '3px',
                    }}
                  >
                    <Box
                      sx={{
                        fontWeight: 'bold',
                      }}
                    >
                      Statut:
                    </Box>

                    <Box>
                      {(() => {
                        if (process.status === 'SUCCESS')
                          return (
                            <Box
                              sx={{
                                display: 'flex',
                                gap: '3px',
                              }}
                            >
                              <Box>Terminé </Box>
                              <CheckCircleOutlineIcon
                                fontSize="small"
                                sx={{ color: 'green' }}
                              />
                            </Box>
                          );
                        if (process.status === 'ERROR')
                          return (
                            <Box
                              sx={{
                                display: 'flex',
                                gap: '3px',
                              }}
                            >
                              <Box>Erreur </Box>
                              <ErrorOutlineIcon
                                fontSize="small"
                                sx={{ color: 'red' }}
                              />
                            </Box>
                          );
                        if (process.status === 'RUNNING')
                          return (
                            <Box
                              sx={{
                                display: 'flex',
                                gap: '6px',
                              }}
                            >
                              <Box>En cours </Box>
                              <Box>
                                <CircularProgress size={15} />
                              </Box>
                            </Box>
                          );
                      })()}
                    </Box>
                  </Box>
                  {process.status === 'SUCCESS' && process.article?.id && (
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '3px',
                        marginTop: '10px',
                      }}
                    >
                      <Link
                        href={`#${generatePath(paths.SLIDESHOW_EDIT, {
                          id: process.article.id,
                        })}`}
                        target="_blank"
                      >
                        Voir le diaporama
                      </Link>
                    </Box>
                  )}
                </Box>
                <Button
                  variant="text"
                  onClick={() => {
                    setActiveProcessId((actProcessId) =>
                      actProcessId === process.id ? null : process.id,
                    );
                  }}
                  sx={{
                    color: grey[700],
                  }}
                  startIcon={
                    activeProcessId === process.id ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )
                  }
                >
                  {activeProcessId === process.id
                    ? 'Masquer Détails'
                    : 'Voir détails'}
                </Button>
              </Box>
              <Box
                sx={{
                  display: activeProcessId === process.id ? 'block' : 'none',
                  marginTop: '20px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '3px',
                    }}
                  >
                    <Box
                      sx={{
                        fontWeight: 'bold',
                      }}
                    >
                      Temps de traitement:
                    </Box>
                    <Box>
                      {' '}
                      {(() => {
                        const createdAt: Date = new Date(process.createdAt);
                        const updatedAt: Date = new Date(process.updatedAt);
                        const time_difference_ms: number =
                          updatedAt.getTime() - createdAt.getTime();
                        const minutes: number = Math.floor(
                          time_difference_ms / (1000 * 60),
                        );
                        const seconds: number = Math.floor(
                          (time_difference_ms / 1000) % 60,
                        );
                        return `${
                          minutes ? `${minutes} minutes et ` : ''
                        } ${seconds} secondes`;
                      })()}
                    </Box>
                  </Box>
                  {process.recipeNumber && (
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '3px',
                      }}
                    >
                      <Box
                        sx={{
                          fontWeight: 'bold',
                        }}
                      >
                        Nombre de recettes demandées:
                      </Box>
                      <Box> {process.recipeNumber}</Box>
                    </Box>
                  )}
                </Box>
                {isCreationSideshow && (
                  <Box
                    sx={{
                      mt: '5px',
                      display: 'flex',
                      gap: '3px',
                    }}
                  >
                    <Box
                      sx={{
                        fontWeight: 'bold',
                      }}
                    >
                      Titre généré:
                    </Box>
                    <Box>{process.generatedTitle}</Box>
                  </Box>
                )}

                {process.status === 'ERROR' && (
                  <Box
                    sx={{
                      mt: '5px',
                      display: 'flex',
                      gap: '3px',
                    }}
                  >
                    <Box
                      sx={{
                        fontWeight: 'bold',
                      }}
                    >
                      Message d'ereur:
                    </Box>
                    <Box> {process.errorMsg || '---'}</Box>
                  </Box>
                )}
              </Box>
            </Card>
          );
        })}
    </Card>
  );
};
